// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__0wMzO","lastBreadcrumb":"Breadcrumb_lastBreadcrumb__yDuwo","breadcrumbWrapper":"Breadcrumb_breadcrumbWrapper__sojVK"};